<template>
  <div class="content">
    <m-header>
      <div slot="nav"></div>
    </m-header>
    <div class="container">
      <div class="row">
        <div class="wanl-entry">
          <div class="head" style="margin: 0 auto 20px;">
            <div class="title">
              <p>设计师认证申请</p>
            </div>
            <div class="entry-content">
              <ol class="ui-step ui-step-4">
                <li class="step-start step-done">
                  <div class="ui-step-line"></div>
                  <div class="ui-step-cont">
                    <span class="ui-step-cont-number">1</span>
                    <span class="ui-step-cont-text">注册账号</span>
                  </div>
                </li>
                <li class="step-active">
                  <div class="ui-step-line"></div>
                  <div class="ui-step-cont">
                    <span class="ui-step-cont-number">2</span>
                    <span class="ui-step-cont-text">资质信息</span>
                  </div>
                </li>
                <li class="step-end">
                  <div class="ui-step-line"></div>
                  <div class="ui-step-cont">
                    <span class="ui-step-cont-number">3</span>
                    <span class="ui-step-cont-text">提交审核</span>
                  </div>
                </li>
              </ol>
            </div>
          </div>
          <div class="title-container"><span class="title">主体资质认证</span></div>
          <div style="text-align: center; padding-top: 15px; padding-bottom: 15px;">
            <p style="font-size: 32px;">
              欢迎加入医小智
            </p>
            <p style="font-size: 15px; padding-top: 10px;font-family:'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif">
              感谢您的信任和选择医小智互联网医疗服务平台，医小智将为您提供设计师职业生涯晋升之路，灵活就业，规划收入从医小智开始。<br>
            </p>
          </div>
          <div class="form">
            <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px"
              size="medium " class="demo-ruleForm">
              <el-form-item label="姓名:" prop="name">
                <el-input v-model="ruleForm.name" placeholder="请输入联系人姓名"></el-input>
              </el-form-item>
			  <el-form-item label="所属地:" prop="location">
			  	<Map @selMap="selMap" v-if="ruleForm.location!='手动输入'"></Map>
          <el-input v-model="address" v-else/>
			  </el-form-item>
              <el-form-item label="联系方式:" prop="mobile">
                <el-input v-model="ruleForm.mobile" maxlength="11" disabled show-word-limit placeholder="请输入联系人手机号"></el-input>
              </el-form-item>
              <el-form-item required label="证件类型:">
                <el-input disabled placeholder="身份证"></el-input>
              </el-form-item>
              <el-form-item label="身份证号:" prop="idcardNum">
                <el-input v-model="ruleForm.idcardNum" maxlength="18" show-word-limit placeholder="请输入身份证号"></el-input>
              </el-form-item>
              <el-form-item label="身份证正面照：" prop="idcardImgFront">
                <el-upload
                  class="upload-demo"
                  style="width: 90%;height: 90%;"
                  drag
                  action
                  :show-file-list="false"
                  :before-upload="beforeIdcardUpload"
                  :http-request="uploadFile"
                  :data="{objectType:'15',objectTag:''}"
                  :auto-upload="true">
                 <!-- <img v-if="idcardFrontCert" :src="idcardFrontCert" class="avatar" style="width:100%;height:100%"> -->
                  <img v-if="idcardFrontCert" :src="idcardFrontCert" class="avatar" style="width:100%;height:100%">
                 <div v-else>
                   <i class="el-icon-upload"></i>
                   <div class="el-upload__text"><em>身份证正面</em></div>
                 </div>
                </el-upload>
                <div class="del-box">
                  <div class="del-box-bor">
                    <div class="my-del" :style="!idcardFrontCert?'display: none;':'display: block;'" @click="fileRemove(15)">
                      <i class="el-icon-close"></i>
                      <i class="el-icon-check"></i>
                    </div>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="身份证反面照：" prop="idcardImgBack">
                <el-upload
                  class="upload-demo"
                  drag
                  action
                  :show-file-list="false"
                  :before-upload="beforeIdcardUpload"
                  :http-request="uploadFile"
                  :data="{objectType:'16',objectTag:''}"
                  :auto-upload="true">
                  <img v-if="idcardBackCert" :src="idcardBackCert" class="avatar" style="width:100%;height:100%;z-index: 10;">
                  <div v-else>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text"><em>身份证反面</em></div>
                  </div>
                </el-upload>
                <div class="del-box">
                  <div class="del-box-bor">
                    <div class="my-del" :style="!idcardBackCert?'display: none;':'display: block;'" @click="fileRemove(16)">
                      <i class="el-icon-close"></i>
                      <i class="el-icon-check"></i>
                    </div>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="本人手持身份证：" prop="idcardImgHand">
                <el-upload
                  class="upload-demo"
                  drag
                  action
                  :show-file-list="false"
                  :before-upload="beforeIdcardUpload"
                  :http-request="uploadFile"
                  :data="{objectType:'17',objectTag:''}"
                  :auto-upload="true">
                  <img v-if="idcardHandCert" :src="idcardHandCert" class="avatar" style="width:100%;height:100%">
                  <div v-else>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text"><em>本人手持身份证正面照</em></div>
                  </div>
                </el-upload>
                <div class="del-box">
                  <div class="del-box-bor">
                    <div class="my-del" :style="!idcardHandCert?'display: none;':'display: block;'" @click="fileRemove(17)">
                      <i class="el-icon-close"></i>
                      <i class="el-icon-check"></i>
                    </div>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="资质认证:" prop="certificateType">
                <el-select v-model="ruleForm.certificateType" placeholder="请选择认证方式">
                  <el-option label="上传毕业证书" value="00"></el-option>
                  <el-option label="上传技工证书" value="01"></el-option>
                  <el-option label="上传病例验证和职业简历" value="02"></el-option>
                </el-select>
              </el-form-item>
            <el-form-item prop="certificate" v-if="ruleForm.certificateType!=''">
                <el-upload class="upload-demo"
                  action
                  :before-upload="beforeUpload"
                  :http-request="uploadFile"
                  :data="{objectType:'06',objectTag:''}"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :on-exceed="handleExceed"
                  :auto-upload="true"
                  :limit="5"
                  :list-type="pdfFile"
                  multiple>
                  <el-button slot="trigger" size="small" type="warning">上传证书<i
                    class="el-icon-upload el-icon--right"></i></el-button>
                </el-upload>
              </el-form-item>
              <el-dialog :visible.sync="dialogVisible">
               <img width="100%" :src="dialogImageUrl" alt />
              </el-dialog>
              <el-form-item>
                <el-checkbox class="agree" v-model="isAgree">
                  我已阅读并同意遵守
                  <a @click.prevent="openAgree('02')">入驻协议</a> 和
                  <a @click.prevent="openAgree('03')">医小智服务准则条款</a>
                </el-checkbox>
              </el-form-item>
              <el-form-item>
                <el-button type="success" @click="submitForm('ruleForm')">立即创建</el-button>
                <el-button @click="resetForm('ruleForm')">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <el-dialog :title="dialogTitle" :visible.sync="dialogContentVisible" :center="true" width="60%" top="8vh" >
        <div class="dialog-content">
          <div v-html="dialogContent"></div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="closeAgree()">我已阅读</el-button>
        </span>
      </el-dialog>
    </div>
    <m-footer></m-footer>
  </div>
</template>
<script>
  import MHeader from '/common/MHeader'
  import MFooter from '/common/MFooter'
  import Map from '../../components/map'
  import {
    uploadByPieces
  } from "../../../common/upload.js";
  import {mapState} from 'vuex'
  import {
    setStore,
    getStore,
    removeStore
  } from '/utils/storage.js'
  export default {
    data() {
      var validateImage = (rule, value, callback) => {
        console.log('this.checkImgSuccess:',this.checkImgSuccess)
        if (!this.checkImgSuccess) {
        console.log('this.checkImgSuccess:',this.checkImgSuccess)
          callback(new Error('请先上传资质证书'))
        } else {
          callback()
        }
      }
      //身份证正面校检
      var validateIdcardImgFront = (rule, value, callback) => {
        if (!this.checkIdcardImgFrontSuccess) {
          callback(new Error('请先上传正面身份证照片'))
        } else {
          callback()
        }
      };
      //身份证反面校检
      var validateIdcardImgBack = (rule, value, callback) => {
        if (!this.checkIdcardImgBackSuccess) {
          callback(new Error('请先上传反面身份证照片'))
        } else {
          callback()
        }
      };
      //本人手持身份证校检
      var validateIdcardImgHand = (rule, value, callback) => {
        if (!this.checkIdcardImgHandSuccess) {
          callback(new Error('请先上传本人手持身份证照片'))
        } else {
          callback()
        }
      };
      //身份证号格式校验
      var validateIdcardNum = function (rule, value, callback) {
        if (value === '') {
          callback(new Error('身份证号不能为空'))
        } else {
            const reg =
              /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(([0-2][1-9])|10|20|30|31)\d{3}(\d|X|x)$/;
            const card = reg.test(value);
            if (!card) {
              callback(new Error("身份证号格式有误！"));
            } else {
              callback();
            }
        }
      }
      //手机号格式校验
      var validatePhone = function (rule, value, callback) {
        if (value === '') {
          callback(new Error('手机号不能为空'))
        } else if (!/^1\d{10}$/.test(value)) {
          callback(new Error('手机号格式错误'))
        } else {
          callback()
        }
      }
      //地区校验
      var validateLocation = function (rule,value,callback) {
        if(value.provinceValue === ''){
          callback(new Error('所属地区不能为空'))
        }else {
          callback()
        }
      }
      return {
        pdfFile:'picture',
        checkImgSuccess: false,
        checkIdcardImgFrontSuccess: false,
        checkIdcardImgBackSuccess: false,
        checkIdcardImgHandSuccess: false,
        dialogImageUrl: "",
        dialogVisible: false,
        dialogContentVisible: false,
        dialogTitle: '',
        dialogContent: '',
        formData: "",
        temptoken: '',
        certList:[], //技师资格证书
        idcardFrontCert:'',
        idcardBackCert:'',
        idcardHandCert:'',
        isAgree: false,
        dialogVisible1: false,
        dialogVisible2: false,
        agreement: '',
        agreement1: '',
        agreetitle: '',
        agreetitle1: '',
        address: '',
        ruleForm: {
          mobile: '',
          location: '',
          name: '',
          idcardNum: '',
          certificateType:''
        },
        rules: {
          name: [{
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          }],
          mobile: [{
            required: true,
            validator: validatePhone,
            trigger: 'blur'
          }],
          location: [{
            required: true,
            validator: validateLocation,
            trigger: 'blur'
          }],
          idcardNum: [{
            required: true,
            validator: validateIdcardNum,
            trigger: 'blur'
          }],
          certificateType: [{
            required: true,
            message: '请选择认证方式',
            trigger: 'change'
          }],
          certificate: [{
            required: true,
            validator: validateImage,
            trigger: 'change'
          }],
          idcardImgFront: [{
            required: true,
            validator: validateIdcardImgFront,
            trigger: 'change'
          }],
          idcardImgBack: [{
            required: true,
            validator: validateIdcardImgBack,
            trigger: 'change'
          }],
          idcardImgHand: [{
            required: true,
            validator: validateIdcardImgHand,
            trigger: 'change'
          }]
        }
      };
    },
    computed: {
      ...mapState(['common','user'])
    },
    components: {
      MHeader,
      MFooter,
      Map
    },
    methods: {
      async uploadFile({response,file,data}) {
        var loading = this.$loading({text: '等待上传完成，已上传 0%'});
        var that = this
        uploadByPieces({
          file: file, // 文件
          data: data,
          pieceSize: 3, // 分片大小
          concurrent: 3,
          process: res => {
            loading.setText('等待上传完成，已上传'+res+'%')
            console.log('分片上传 -> process', res)
            if (res == 100) {
              loading.close();
            }
          },
          success: res => {
            if(data.objectType=='06' && data.objectTag=='') {
                this.checkImgSuccess = true
                this.$refs.ruleForm.clearValidate('certificate')
                this.certList.push(res.data.url)
            }else if (data.objectType=='15' && data.objectTag==''){
              this.checkIdcardImgFrontSuccess = true
              this.$refs.ruleForm.clearValidate('idcardImgFront')
              this.idcardFrontCert = res.data.url
            }else if (data.objectType=='16' && data.objectTag==''){
              this.checkIdcardImgBackSuccess = true
              this.$refs.ruleForm.clearValidate('idcardImgBack')
              this.idcardBackCert = res.data.url
            }else if (data.objectType=='17' && data.objectTag==''){
              this.checkIdcardImgHandSuccess = true
              this.$refs.ruleForm.clearValidate('idcardImgHand')
              this.idcardHandCert = res.data.url
            }
            loading.close();
            // console.log('分片上传 -> success', res)
          },
          error: e => {
            // console.log('分片上传 -> error', e)
          }
        })
      },
      submitForm(formName) {
        if (!this.isAgree) {
          this.$yxz.msg('请阅读并同意相关注册协议')
          return false
        }
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let formData = new FormData();
            for (var key in that.ruleForm) {
              formData.append(key, that.ruleForm[key]);
            }
            // formData.append('desServCataList', this.fileLists);

            that.formData = formData;
            this.addForm();
            // this.$refs.ruleForm.resetFields()//清除表单信息
            // this.$refs.upload.clearFiles()//清空上传列表
            // this.fileList = []//集合清空
          } else {
            this.$yxz.msg('请检查各项内容是否全部填写')
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.ruleForm.file = "";
        this.$refs.upload.clearFiles();
      },
      handleRemove(file, fileList) {
        this.checkImgSuccess = false
      },
      handlePreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleExceed() {
        this.$message({
          type: 'error',
          message: '最多支持5个图片上传'
        })
      },
      // 上传前处理
      beforeUpload(file) {
        let fileSize = file.size
        const FIVE_M = 20 * 1024 * 1024;
        //大于5M，不允许上传
        if(fileSize>FIVE_M){
          this.$message.error("最大上传10M")
          return false
        }
        if(this.ruleForm.certification == ''){
          this.$message.error("请先选择认证方式")
          return false
        }
        //判断文件类型
        let fileName = file.name
        let reg = /^.+\.(pdf|jpeg|png|jpg|zip|rar)$/
        let pdf = /^.+\.(pdf|zip|rar)$/
        this.pdfFile = pdf.test(fileName)?'text':'picture'
        if (!reg.test(fileName)) {
          this.$message.error("pdf|jpeg|png|jpg|zip|rar")
          return false
        }
        return true
      },
      beforeIdcardUpload(file) {
        let fileSize = file.size
        const FIVE_M = 20 * 1024 * 1024;
        //大于5M，不允许上传
        if(fileSize>FIVE_M){
          this.$message.error("最大上传20M")
          return false
        }
        //判断文件类型
        let fileName = file.name
        let reg = /^.+\.(pdf|jpeg|png|jpg)$/
        if (!reg.test(fileName)) {
          this.$message.error("只能上传pdf|jpeg|png|jpg格式")
          return false
        }
        return true
      },
      //添加
      addForm() {

        var data = {
          nickName: this.formData.get('name'),
          mobile: this.formData.get('mobile'),
          idcardNum: this.ruleForm.idcardNum,
          idcardImgFront: this.idcardFrontCert,
          idcardImgBack: this.idcardBackCert,
          idcardImgHand: this.idcardHandCert,
          certType: this.formData.get('certificateType'),
          cert: this.certList.join(','),
          location: this.ruleForm.location=='手动输入'?this.address:this.ruleForm.location,

          //以下字段不再用，传值是为了防止后端判断为空
          contact: this.formData.get('name'),
          sex: '00',
          desSoftType: '01',
          desSoftExtra: '01',
          // desServCataList: '01'
        }
        // console.log('data:',data)
        this.$api.post({
          url: '/user/des-auth',
          data: data
        }).then(res => {
          if (res.code == 200) {
            this.$yxz.msg('申请成功，请等待审核结果', 'success')
            this.$router.push({
              path: "/"
            });
          } else {
            this.$yxz.msg(res.msg);
          }
        })
      },
      openAgree(agreeType) {
        this.$api.get({
          url: '/biz/agree/' + agreeType,
          isToken: false
        }).then(res=>{
          if (res.code === 200) {
            this.dialogContent = this.$yxz.showHtml(res.data.agreeContent) || '';
            this.dialogTitle = res.data.agreeTitle || ''
            this.dialogContentVisible = true;
          }
        })
      },
      closeAgree() {
        this.dialogTitle = '';
        this.dialogContent = '';
        this.dialogContentVisible = false;
      },
      selMap(provinceValue,cityValue,RegionValue){
        this.ruleForm.location = provinceValue + cityValue + RegionValue
      },
      fileRemove(i){
        /*    this.certList.push(res.data.url)
              this.idcardFrontCert = res.data.url
              this.idcardBackCert = res.data.url
              this.idcardHandCert = res.data.url*/
        if(i==15){
          this.idcardFrontCert = ''
          this.checkIdcardImgFrontSuccess = false
        }else if(i==16){
          this.idcardBackCert = ''
          this.checkIdcardImgBackSuccess = false
        }else if(i==17){
          this.idcardHandCert = ''
          this.checkIdcardImgHandSuccess = false
        }
        // console.log('url:',
        // this.idcardFrontCert,
        // this.idcardBackCert,
        // this.idcardHandCert,
        // this.certList
        // )
      },
    },
    mounted() {
      this.$yxz.title("医小智 - 设计师认证申请")
      this.temptoken = getStore('token')
      this.$api.get({
        url: '/common/cataServ',
        isToken: false
      }).then(res => {
        if (res.code == 200) {
          this.$store.commit('common/recordServCata',res.data)
        }
      })
      this.ruleForm.mobile = this.user.loginName;
    }
  }
</script>

<style lang="scss" scoped>
  .content {
    width: 100%;
    overflow: auto;
  }

  .container {
    width: 60%;
    margin-right: auto;
    margin-left: auto;
    padding-left: 15px;
    padding-right: 15px;
    margin-top: 20px;
  }

  .row {
    margin-left: -15px;
    margin-right: -15px;
  }

  .wanl-entry>div {
    position: relative;
    background: #fff;
    width: 100%;
    // margin: 0 auto 20px;
  }

  .wanl-entry .head .title {
    text-align: center;
    margin: 0;
    color: #666;
    padding: 15px;
    border-bottom: 1px dashed #e0e0e0;
  }

  .wanl-entry .entry-content {
    padding: 20px;
  }

  [v-cloak] {
    display: none;
  }

  .content {
    background: #f5f5f5;
    overflow: hidden;
  }

  .btn-lg,
  .btn-group-lg>.btn {
    height: 38px;
    line-height: 1.2;
  }

  .wanl-entry .head .title {
    text-align: center;
    margin: 0;
    color: #666;
    padding: 15px;
    border-bottom: 1px dashed #e0e0e0;
  }

  .wanl-entry .head .title p {
    font-size: 16px;
    font-weight: 700;
    color: #555;
    margin: 0;
    line-height: 24px;
  }

  .wanl-entry .title-container {
    padding: 10px 0 10px 15px;
    font-size: 15px;
    border-bottom: 1px dashed #ececec;
  }

  .wanl-entry .title-container .title {
    border-left: 4px solid #e74c3c !important;
    padding-left: 10px;
  }

  .wanl-entry .entry-content {
    padding: 20px;
  }

  .wanl-entry .info {
    padding: 20px 50px;
    text-align: center;
  }

  ol {
    list-style: none outside none;
    margin: 0;
    padding: 0;
  }

  .ui-step {
    color: #b7b7b7;
    padding: 0 60px;
    margin-bottom: 35px;
    position: relative;
  }

  .ui-step:after {
    display: block;
    content: "";
    height: 0;
    font-size: 0;
    clear: both;
    overflow: hidden;
    visibility: hidden;
  }

  .ui-step li {
    float: left;
    position: relative;
  }

  .ui-step .step-end {
    width: 120px;
    position: absolute;
    top: 0;
    right: -60px;
  }

  .ui-step-line {
    height: 5px;
    background-color: #e0e0e0;
    margin-top: 20px;
  }

  .step-end .ui-step-line {
    display: none;
  }

  .ui-step-cont {
    width: 120px;
    position: absolute;
    top: 0;
    left: -15px;
    text-align: center;
  }

  .ui-step-cont-number {
    display: inline-block;
    position: absolute;
    left: 0;
    top: 0;
    width: 40px;
    height: 40px;
    line-height: 35px;
    color: #fff;
    border-radius: 50%;
    border: 2px solid #fff;
    font-size: 16px;
    background-color: #d8d8d8;
  }

  .ui-step-cont-text {
    position: relative;
    top: 45px;
    left: -42px;
    font-size: 12px;
  }

  .ui-step-4 li {
    width: 50%;
  }

  .step-done .ui-step-cont-number {
    background-color: #18bc9c;
  }

  .step-done .ui-step-cont-text {
    color: #18bc9c;
  }

  .step-done .ui-step-line {
    background-color: #18bc9c;
  }

  /* Active */
  .step-active .ui-step-cont-number {
    background-color: #18bc9c;
  }

  .step-active .ui-step-cont-text {
    color: #18bc9c;
    font-weight: bold;
  }

  .step-active .ui-step-line {
    background-color: #e0e0e0;
  }

  .form {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;
    margin-bottom: 20px;
  }
  .dialog-content {
    height: 55vh;
    overflow: auto;
    padding: 30px 0;
  }
  .del-box{
    width: 40px;
    height: 50px;
    box-sizing: border-box;
    position: absolute;
    top: -20px;
    right: -9px;
    z-index: 99;
    overflow: hidden;
    transform: rotate(-45deg);
  }
  .my-del{
    background-color: #13ce66;
    border-radius: 5px;
    width: 40px;
    height: 50px;
    position: absolute;
    z-index: 99;
  }
  .del-box-bor{
    width: 100%;
    height: 100%;
    position: absolute;
    top: -4px;
    right: 26px;
    transform: rotate(-45deg);
    .el-icon-close{
      margin-top: 31px;
      margin-left: 21px;
      display:none;
    }
    .el-icon-check{
      color:white;
      margin-left: 20px;
      margin-top: 31px;
      transform: rotate(90deg);
    }
  }
  .my-del:hover{
    .el-icon-close{
      color: red;
      display:block;
      transform: scale(1.5);
    }
    .el-icon-check{
      display: none;
    }
    background-color: transparent;
    position: absolute;
    transform: rotate(0deg);
  }
</style>



// WEBPACK FOOTER //
// designerAuth.vue?05caeb02